module.exports = __webpack_public_path__ + "img/LIVE.3d4220b5.png";